/* eslint-disable no-console */

/**
 * Sets an item into session storage
 * @param key Is the key of the object
 * @param value Is the value of the object
 * @returns A boolean, with true representing that it did successfully set it with false representing that it did not successfully set it
 */
const setSessionStorage = (key: string, value: object): boolean => {
    try {
        globalThis.sessionStorage.setItem(key, JSON.stringify(value));
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

/**
 * Gets an item from session storage
 * @param key Is the key that we are trying to retrieve
 * @returns Either the object (parsed) or null if it is did not find it
 */
const getSessionStorage = (key: string): object | null => {
    try {
        const data = globalThis.sessionStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error(error);
        return null;
    }
};

/**
 * Removes an item from session storage
 * @param key The key of the object we want to remove
 * @returns A boolean, true if it was successfully removed, false if it was not removed
 */
const removeSessionStorage = (key: string): boolean => {
    try {
        globalThis.sessionStorage.removeItem(key);
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

/**
 * Clears session storage.
 * NB: You should not use this unless required as it clears the session storage for the application, which could have unforseen repercussions.
 * @returns A boolean, true if it was successfully cleared, false if it was not cleared
 */
const clearSessionStorage = (): boolean => {
    try {
        globalThis.sessionStorage.clear();
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export { clearSessionStorage, getSessionStorage, removeSessionStorage, setSessionStorage };

